/**
 * Powers reference value fields
 *
 * @author Yi Liu (yliu@yext.com)
 */
goog.provide('yext.location.ReferenceValueList');
goog.provide('yext.location.ReferenceValueListModel');

goog.require('yext');
goog.require('yext.location.ReferenceValue');
goog.require('yext.location.ReferenceValueModel');
goog.require('yext.location.helpers');


/**
 * @param {!jQuery} $ctx Context for finding field elements
 * @constructor
 */
yext.location.ReferenceValueList = function($ctx) {
  this.$ctx = $ctx;
  this.$field = $ctx.find('.js-reference-value-list-field').addBack()
    .filter('.js-reference-value-list-field');
  this.$list = this.$field.find('.js-reference-value-list');
  this.$searchItemTemplate = $(this.$field.find('.js-search-item-template').html());
  this.$fieldValue = this.$field.find('.js-reference-value-list-field-value');
  this.$elidedMode = this.$field.find('.js-reference-value-elided-mode');

  // Map the instance to the element
  this.$field.data('field', this);

  this.timestamp = this.$field.data('timestamp');
  this.elidedModeItemCount = this.$elidedMode.data('elidedModeItemCount');
  this.items = this.parseFromDOM();
  this.excludedValues = this.getSelectedValues();
  this.labelsCache = {};

  this.bindElided();
  this.fillLabelsCache();
  this.updateItems();
  this.setFieldValue();
  this.storeValue();
  this.bindAddItem();
  this.bindSortable();

  this.assetOrOriginal = true;
  this.originalValue = this.$fieldValue.val();
};

/**
 * Bind the elided mode delete for edit
 */
yext.location.ReferenceValueList.prototype.bindElided = function() {
  var self = this;

  this.$elidedMode.find('.js-remove-elided-lists').click(function() {
    self.elidedModeItemCount = undefined;
    self.onUpdate();
  });
};

/**
 * Get an item by its value
 *
 * @return {yext.location.ReferenceValue}
 */
yext.location.ReferenceValueList.prototype.getItem = function(value) {
  for (var i = 0; i < this.items.length; i++) {
    if (this.items[i].model.value == value) {
      return this.items[i];
    }
  }
};

/**
 * Cache some labels if they need to be restored
 */
yext.location.ReferenceValueList.prototype.fillLabelsCache = function() {
  for (var i = 0; i < this.items.length; i++) {
    var model = this.items[i].model;
    this.labelsCache['' + model.value] = model.label;
  }
};

/**
 * Static constructor that will only init the field once
 * @param {!jQuery} $ctx Context for finding field elements
 */
yext.location.ReferenceValueList.field = function($ctx) {
  if ($ctx.data('field') instanceof yext.location.ReferenceValueList) {
    return $ctx.data('field');
  }
  return new yext.location.ReferenceValueList($ctx);
};

/**
 * Parse the initial state from the DOM
 *
 * @return {!Array.<yext.location.Long>}
 */
yext.location.ReferenceValueList.prototype.parseFromDOM = function() {
  var self = this;
  var items = [];

  this.$list.find('li').each(function() {
    var item = new yext.location.ReferenceValue($(this));
    items.push(item);
    self.bindSearchItem(item);
  });

  return items;
};

/**
 * Store an array of yext.location.ReferenceValueModel objects
 *
 * @return {!Array.<yext.location.ReferenceValueModel>}
 */
yext.location.ReferenceValueList.prototype.storeValue = function() {
  this.storedReferenceValueModels = $.map(this.items, function(item) {
    return item.model.copy();
  });
  this.storedElidedModeItemCount = this.elidedModeItemCount;
};

/**
 * Bind add item interaction
 */
yext.location.ReferenceValueList.prototype.bindAddItem = function() {
  var self = this;
  this.$field.find('.js-add-item').on('click', function() {
    self.addItem();
  });
};

/**
 * Bind sortable interaction
 */
yext.location.ReferenceValueList.prototype.bindSortable = function() {
  var self = this;
  this.$list.sortable({
    axis: 'y',
    start: function(event, ui) {
      $(this).attr('data-previndex', ui.item.index());
    },
    update: function(event, ui) {
      var oldIndex = $(this).attr('data-previndex');
      $(this).removeAttr('data-previndex');
      var newIndex = ui.item.index();
      self.items.splice(newIndex, 0, self.items.splice(oldIndex, 1)[0]);
      self.onUpdate();
    },
  });
};

/**
 * Add an item to the UI and bind it
 *
 * @return {yext.location.Long}
 */
yext.location.ReferenceValueList.prototype.addItem = function() {
  var $searchItemTemplate = this.$searchItemTemplate.clone();
  this.$list.append($searchItemTemplate);

  var searchItem = new yext.location.ReferenceValue($searchItemTemplate);
  searchItem.excludeValues(this.excludedValues);
  searchItem.focus();
  this.items.push(searchItem);
  this.bindSearchItem(searchItem);

  return searchItem;
};

/**
 * Bind the newly added searchable item by listening to its 'updated' message
 *
 * @param {yext.location.Long} searchItem
 */
yext.location.ReferenceValueList.prototype.bindSearchItem = function(searchItem) {
  var self = this;

  $(searchItem).on('updated', function() {
    // This item got deleted
    if (this.model.value === undefined) {
      self.removeItem(this);
    } else { // An option got selected
      self.onUpdate();
    }
  });
};

/**
 * Remove the given item from the items list
 *
 * @param {yext.location.Long} item The Item to be removed
 */
yext.location.ReferenceValueList.prototype.removeItem = function(item) {
  item.$ctx.remove();
  var index = this.items.indexOf(item);
  if (index > -1) {
    this.items.splice(index, 1);
    item.destroy();
    this.onUpdate();
  }
};

/**
 * Update the field value and trigger an updated message
 */
yext.location.ReferenceValueList.prototype.onUpdate = function() {
  this.setFieldValue();
  this.message('updated');
  $(this).trigger('update.struct');
  this.updateItems();
  this.render();
  this.updateAssetOrOriginal(false);
};

/**
 * Update the UI to match the model
 */
yext.location.ReferenceValueList.prototype.render = function() {
  this.$elidedMode.toggle(!!this.elidedModeItemCount);
  if (this.elidedModeItemCount) {
    var message = yext.msgn('1 list', '{0} lists', this.elidedModeItemCount);
    this.$elidedMode.find('.js-elided-message').text(message);
  }
};

/**
 * Update the ReferenceValue items with coordinating info from the list
 */
yext.location.ReferenceValueList.prototype.updateItems = function() {
  this.excludedValues = this.getSelectedValues();
  this.items.forEach(function(item) {
    item.excludeValues(this.excludedValues);
  }, this);
};

/**
 * Get the set of currently selected values
 * @return {!Array} List of values
 */
yext.location.ReferenceValueList.prototype.getSelectedValues = function() {
  var values = [];
  this.items.forEach(function(item) {
    if (item.model.value) {
      values.push(String(item.model.value));
    }
  });
  return values;
};

/**
 * Triggers a message with the instance as context
 *
 * @param {string} message The message to be triggered
 */
yext.location.ReferenceValueList.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Reset the model to its initial state
 */
yext.location.ReferenceValueList.prototype.reset = function() {
  this.set({
    'items': this.storedReferenceValueModels,
  });
  this.elidedModeItemCount = this.storedElidedModeItemCount;
  this.onUpdate();
};

/**
 * Set the model based on the given field data
 *
 * @param {!Object} field
 */
yext.location.ReferenceValueList.prototype.set = function(field) {
  var self = this;

  this.fillLabelsCache();

  this.items = [];

  this.$list.empty();
  field['items'].forEach(function(model) {
    var item = self.addItem();
    item.model = new yext.location.ReferenceValueModel(model);
    self.restoreLabel(item.model);
    item.bind();
    item.render();
  });

  this.elidedModeItemCount = field['elidedModeItemCount'];

  if (field['timestamp']) {
    this.timestamp = field['timestamp'];
  }

  this.onUpdate();
};

/**
 * Labels are not sent or received from the backend, so we restore them here
 *
 * @param {yext.location.ReferenceValueModel} item
 */
yext.location.ReferenceValueList.prototype.restoreLabel = function(item) {
  var label = this.labelsCache[item.value];
  if (label) {
    item.label = label;
  }
};

/**
 * Sets a hidden input to the field value, with string keys
 */
yext.location.ReferenceValueList.prototype.setFieldValue = function() {
  this.$fieldValue.val(yext.JSON.stringify(this.getData()));
};

/**
 * @return {!Object}
 */
yext.location.ReferenceValueList.prototype.getData = function() {
  var values = $.map(this.items, function(item) {
    if (item.model.value && item.model.selected) {
      return item.getData();
    }
  });
  return {
    'items': values,
    'elidedModeItemCount': this.elidedModeItemCount,
    'timestamp': this.timestamp,
  };
};

yext.location.ReferenceValueList.prototype.getJSONData = function() {
  return this.getData();
};

/**
 * Apply values to this field from an asset. Also set the assetOrOriginal flag to true.
 */
yext.location.ReferenceValueList.prototype.applyAsset = function(fieldValues) {
  this.set(fieldValues);
  this.updateAssetOrOriginal(true);
};

/**
 * Update the asset or original flag.
 */
yext.location.ReferenceValueList.prototype.updateAssetOrOriginal = function(fromAsset) {
  if (fromAsset || this.originalValue === this.$fieldValue.val()) {
    this.assetOrOriginal = true;
  } else {
    this.assetOrOriginal = false;
  }
};

/**
 * Type-ubiquitous function for checking assetOrOriginal flag.
 */
yext.location.ReferenceValueList.prototype.checkAssetOrOriginalFlag = function() {
  return this.assetOrOriginal;
};

/**
 * The after save function when this entity reference list field is a child of a struct.
 */
yext.location.ReferenceValueList.prototype.setFromStruct = function(fieldValues, $display, $viewTemplate /* unused */, cannotEdit) {
  this.set(fieldValues);
  this.storeValue();
  $display.empty().append(this.getDisplayValue(cannotEdit));

  const genericListItem = this.$ctx.parents('.js-generic-list-item').length;
  const entityEdit = this.$ctx.parents('.location-edit-page-body').length;

  // This is a band-aid fix to prevent a bug where generic lists of structs with a reference
  // value list property submit incorrectly after a rerender. By refreshing the page after
  // a successful submission we prevent the post-rerender submission from ever being possible.
  if (genericListItem && entityEdit) {
    window.location.reload(true);
  }

  this.assetOrOriginal = true;
  this.originalValue = this.$fieldValue.val();
};

/**
 * @return {boolean} True if the field is empty
 */
yext.location.ReferenceValueList.prototype.isEmpty = function() {
  return this.items.length === 0 && !this.elidedModeItemCount;
};

/**
 * Get the display value for this field used in display mode
 */
yext.location.ReferenceValueList.prototype.getDisplayValue = function(cannotEdit) {
  var indeterminate = false;
  for (var i = 0; i < this.items.length; i++) {
    if (this.items[i].model.indeterminate) {
      indeterminate = true;
      break;
    }
  }

  if (indeterminate) {
    return yext.location.helpers.variousContentMessage();
  } else if (this.isEmpty()) {
    return yext.location.helpers.emptyFieldMessage(cannotEdit);
  } else if (this.elidedModeItemCount) {
    var html = '<span class="elided-mode-count">';
    html += yext.msgn('1 list', '{0} lists', this.elidedModeItemCount);
    html += '</span>';
    return this.viewMode(html);
  } else {
    var display = '<ul>';
    for (var i = 0; i < this.items.length; i++) {
      display += '<li tid="reference-value-list-item-display">' + this.items[i].model.label + '</li>';
    }
    display += '</ul>';
    return this.viewMode(display);
  }
};

/**
 * Wrap provide html with the correct context for view mode
 * @param {string} html
 * @return {string}
 */
yext.location.ReferenceValueList.prototype.viewMode = function(html) {
  return '<div class="reference-value-list-view" tid="reference-value-list-display">' + html + '</div>';
};

/**
 * Clears the field
 */
yext.location.ReferenceValueList.prototype.clear = function() {
  this.$list.empty();
  this.items = [];
  this.elidedModeItemCount = 0;
  this.onUpdate();

  // reset asset approvals values
  this.updateAssetOrOriginal(false);
};
